<!--
 * @Description: 渲染组件
 * @Author: guoyu01
 * @Date: 2019-09-04 10:44:35
 * @LastEditTime: 2020-04-14 21:15:04
 * @LastEditors: fanglei@zuoyebang.com
 -->
<script>
/**
 * @link https://vuejs.org/v2/guide/render-function.html#createElement-Arguments
 */

import isNumber from 'lodash/isNumber'
import isArray from 'lodash/isArray'
import isEmpty from 'lodash/isEmpty'
import set from 'lodash/set'
import get from 'lodash/get'
import isString from 'lodash/isString'
import cloneDeep from 'lodash/cloneDeep'
import omit from 'lodash/omit'
import forEach from 'lodash/forEach'
import Vue from 'vue'
import eventBus from '../eventBus'
import methods, {
  getUrlParams,
} from '../../node_modules/@imp/package/lib/methods'
// import { yikeSellLog, terminalCheck, hybrid } from 'yike-utils'
import yikeSellLog from '../../node_modules/@imp/package/lib/zyb-yike-utils/yikeSellLog'
import terminalCheck from '../../node_modules/@imp/package/lib/zyb-yike-utils/terminalCheck'
import hybrid from '../../node_modules/@imp/package/lib/zyb-yike-utils/hybridProxy'
import dotApi from '../../node_modules/@imp/package/lib/dot-api'
import Bus from '../../node_modules/@imp/package/lib/bus'
import {
  isServer,
  $set,
  observable,
  platform,
} from '../../node_modules/@imp/package/lib/utils'
import { service } from '../../node_modules/@imp/package/lib/request-proxy'

import { ComponentTypeEnum } from '../../node_modules/@imp/package/typings/enum/component-type'
import { getQueryofKey } from '../../utils/getUrlParams'
import { updateFlowPond } from 'cube-dialog-sdk'
/**
 * 给style添加单位，但是我觉得不应该在这，而是在保存的时候
 * @param style
 * @return {*}
 */
const transformStyle = style => {
  ;[
    'width',
    'height',
    'top',
    'left',
    'right',
    'bottom',
    'paddingTop',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
    'marginTop',
    'marginBottom',
    'marginLeft',
    'marginRight',
  ].forEach(key => {
    if (style.hasOwnProperty(key)) {
      // 兼容 auto，100%
      if (isNumber(style[key])) {
        style[key] = style[key] + 'rem'
      }
    }
  })
  return style
}

/**
 * 将事件按照trigger分类，默认是click
 * @param actions
 * @return {*}
 */
const classifyActions = actions => {
  if (!actions || !actions.length) {
    return {}
  }
  return actions.reduce((pre, action) => {
    const { trigger = 'click' } = action
    if (!trigger) {
      return pre
    }
    if (!pre[trigger]) {
      pre[trigger] = [action]
    } else {
      pre[trigger].push(action)
    }
    return pre
  }, {})
}

/**
 * 注册事件
 * @param dNode 当前节点信息
 * @param actions 事件描述信息
 */
const registerActions = (dNode, actions) => {
  if (actions && !isEmpty(actions) && !isEmpty(actions[0]) && !isServer) {
    actions.forEach((action, index) => {
      const { actionType } = action
      const method = methods[action.actionType]
      if (!actionType || !method) {
        return false
      }
      Bus.uid(dNode.uid)
        .bind(window.__PAGE_DATA__)
        .off(actionType, method)
        .on(actionType, method)
    })
  }
}

/**
 * 发布对应trigger、调用uid挂载的事件
 * @param id 响应方id
 * @param trigger 调用方式
 * @param triggerMap 事件分类
 */
const triggerActions = (id, trigger, triggerMap) => {
  const events = triggerMap[trigger]

  if (!id || !trigger || !triggerMap || !events || !events.length || isServer) {
    return false
  }
  events.forEach(({ uid = id, actionType, params }) => {
    Bus.uid(uid || id)
      .bind(window.__PAGE_DATA__)
      .emit(actionType, { ...params, ...{ emitUid: id } })
  })
}

/**
 * 处理数据源
 * @param services 数据源描述
 * @param cb 接口成功回调函数
 * @return props
 */
const triggerService = (services, cb) => {
  let props = {}
  if (isServer || !services || isEmpty(services) || !props) {
    return cb(props)
  }
  const pageData = window.__PAGE_DATA__
  const pageConfig = get(pageData, 'pageInfo.pageConfig', {})
  const globalData = get(pageData, 'pageInfo.globalData', {})
  // 封装request函数
  const request = ({ params, url, method = 'get', origin = '' }, cb) =>
    service[method](
      {
        ...(() => (origin ? { baseURL: origin } : {}))(),
        url,
        params: {
          // 透传flowPond
          flowPond: window.flowPond,
          // 透传url参数
          urlParams: getUrlParams(),
          // 页面id
          pageId: pageData.pageInfo.pageId,
          // 活动id
          actId: pageData.actInfo.actId,
          // globalData
          globalData: Object.assign(globalData, pageConfig),
          ...params,
        },
      },
      cb
    )
  services.forEach(s => {
    request(s, ({ data = {} }) => {
      if (data && !isEmpty(data)) {
        // 获取映射
        const { responseMap } = s
        Object.keys(responseMap).forEach(k => {
          // 根据路径从请求结果取值
          const val = get(data, responseMap[k])
          // 替换组件状态值
          // k可能为a.b.c
          set(props, k, val)
        })
        cb(props)
      }
    })
  })
}

/**
 * 递归渲染组件
 * @param dNode
 * @param h
 * @param bussData
 * @return {Array|*}
 */
const createComponent = (dNode, h, bussData, parent) => {
  if (isEmpty(dNode)) {
    return []
  }

  if (isArray(dNode)) {
    return dNode.map(child => createComponent(child, h, bussData, parent))
  }

  let children = []

  if (dNode.componentList && dNode.componentList.length > 0) {
    dNode.componentList.forEach(c => {
      if (isString(c)) {
        children.push(c)
      } else {
        children.push(createComponent(c, h, bussData, dNode))
      }
    })
  }

  // console.log(dNode, '=====dNode=====')
  // 组件当前状态
  const status = dNode.status
  const propsData = dNode.propsData
  const statusData = propsData[status]
  // 数据源
  const services = dNode.service
  // 坐标位置需要挂载在容器上面
  const style = transformStyle(cloneDeep(statusData['style']))
  // 组件只需要挂载尺寸，不需要挂载位置信息
  const widgetStyle = omit(style, [
    'position',
    'left',
    'top',
    'right',
    'bottom',
  ])
  // 容器样式不挂载padding
  const containerStyle = omit(style, ['paddingTop', 'paddingBottom'])
  const properties = cloneDeep(statusData['description'])
  const isContainer =
    [dNode.type, dNode.oldType].includes(ComponentTypeEnum.container) ||
    dNode.type === ComponentTypeEnum.page ||
    dNode.type === ComponentTypeEnum.dialog
  // 是否为热区
  const isHotarea = dNode.type === ComponentTypeEnum.hotarea

  // 注册事件
  const actions = cloneDeep(statusData['actions'])
  registerActions(dNode, actions)

  return h(
    {
      data() {
        return {
          // 是否添加iphonex-bottom类
          isIphonexBottomCls: true,
          // 缓存页面padding
          originPadding: 0,
          // 本地声明变量
          properties: {
            ...cloneDeep(statusData['description']),
            uid: dNode.uid,
            // 热区组件的componentName为父级节点的name
            componentName: dNode.componentName,
            // 透传actions
            actions,
            // 透传当前节点
            dNode,
            // 透传父级节点
            parentDNode: parent,
          },
        }
      },
      computed: {
        // 处理iphonex底部横栏遮挡问题
        isIphonexBottom() {
          return (
            platform.isIphoneX &&
            style.position === 'fixed' &&
            parseInt(style.bottom) === 0 &&
            style.top === 'auto' &&
            (parent.type === ComponentTypeEnum.page || !parent.type)
          )
        },
      },
      methods: {
        // 根据组件id获取组件信息
        getComponentName(uid) {
          let { componentList } = window.__PAGE_DATA__.pageInfo
          return componentList.filter(component => {
            return component.uid === uid
          })
        },
        handleComponentClick(e) {
          // 阻止冒泡-防止点击容器内组件，事件冒泡到容器
          e.stopPropagation()
          forEach(actions, action => {
            console.log('-----------action-------------------------', action)
            // 处理实物下单的打点参数
            if (action.actionType === 'materialOrder') {
              action.impClick = 57
              let { params } = action
              let skuData = Array.isArray(params.skuData) ? params.skuData : []
              params.skuid = skuData
                .reduce((arr, cur) => {
                  if (cur.skuId) {
                    arr.push(cur.skuId)
                  }
                  return arr
                }, [])
                .join(',')
            }
            if (action && action.trigger && action.trigger !== 'click') {
              return false
            }
            // 放到函数体里面 todo  双按钮触发事件
            if (action.actionType === 'link') {
              if (
                action.params.linkType === 'jumpSpecialPayment' ||
                action.params.linkType === 'jumpOrder'
              ) {
                updateFlowPond({
                  skuId: action.params.linkValue,
                })
              }
              // 如果跳转的是三合一支付页，默认指定impClick为2（立即购买按钮点击）
              if (
                action.params.linkType === 'jumpSpecialPayment' ||
                action.params.linkType === 'jumpSpecialPaymentCS'
              ) {
                action.impClick = 2
                if (
                  action.params.linkValue &&
                  action.skuData &&
                  action.skuData[0]
                ) {
                  action.params.linkValue.saleChannel =
                    action.skuData[0].saleChannel
                }
              }
            } else if (action.actionType === 'dialogEvent') {
              // 如果绑定的是弹窗事件并且是支付弹窗，默认指定impClick为2（立即购买按钮点击）
              let component = this.getComponentName(action.uid)
              if (
                component[0] &&
                component[0].componentName === 'ZybPayDialog'
              ) {
                action.impClick = 2
              }
            } else if (
              action.actionType === 'giveCourse' &&
              action.params?.linkType === 'specify'
            ) {
              // 如果绑定的赠送课程，并且赠送后绑定的是跳转小程序，默认制定impClick为61
              action.impClick = 61
            } else if (action.actionType === 'relatedPaySuccess') {
              action.impClick = 56
            } else if (action.actionType === 'openGrouponApplet') {
              action.impClick = 65
            } else if (action.actionType === 'downHaokeApp') {
              action.impClick = 66
            } else if (
              action.actionType === 'freeCourseWechat' ||
              action.actionType === 'freeCourseWechat2'
            ) {
              action.impClick = 3
            } else if (
              action.actionType === 'wx' ||
              action.actionType === 'wx-auto'
            ) {
              action.impClick = 53
            }
            // 打开微信，['qrcode', 'specify', 'subscribe', 'demo-specify', 'wxkf', 'wxkf-new']和'freeCourseWechat' 、'freeCourseWechat2'，添加applet_appid参数
            let applet_appid = ''
            if (action.actionType === 'freeCourseWechat' && action.params) {
              applet_appid = action.params.appId || ''
            } else if (
              action.actionType === 'freeCourseWechat2' &&
              action.params
            ) {
              const appidMap = window.__AppletTypeIdMap__ || {}
              applet_appid = appidMap[action.params.appletTypeId]
                ? appidMap[action.params.appletTypeId].userName
                : ''
            } else if (
              action.actionType === 'openWxApplet' &&
              action.params &&
              action.params.type === 'subscribe'
            ) {
              applet_appid = action.params.appId || ''
            } else if (
              action.actionType === 'openWxApplet' &&
              action.params &&
              action.params.type === 'qrcode'
            ) {
              // 在代码中写死的这个appid
              applet_appid = 'gh_88c99fc89f2f'
            } else if (
              action.actionType === 'openWxApplet' &&
              action.params &&
              action.params.type === 'specify'
            ) {
              const openWxAppletAppidMap =
                window.__OpentWxAppletTypeIdMap__ || {}
              applet_appid = openWxAppletAppidMap[action.params.appletTypeId]
                ? openWxAppletAppidMap[action.params.appletTypeId].wxUserName
                : ''
            } else if (
              action.actionType === 'openWxApplet' &&
              action.params &&
              action.params.type === 'demo-specify'
            ) {
              const openWxAppletAppidMap =
                window.__OpentWxAppletTypeIdMap__ || {}
              applet_appid = openWxAppletAppidMap[action.params.appletTypeId]
                ? openWxAppletAppidMap[action.params.appletTypeId].wxUserName
                : ''
            }
            // 点击点
            dotApi.componentClick({
              pageId: bussData.pageId,
              niffleruid: dNode.uid,
              componentName: this.properties.componentName,
              groupId: bussData.actInfo.groupId,
              imp: action.impClick,
              elementId: dNode.uid,
              desc: action.dot ? action.dot : action.dotPlaceholder,
              customParams: {
                applet_appid,
                clickIncident: dotApi.actionClickIncident(action),
                componentDisplayName:
                  (this.properties.imageList &&
                    this.properties.imageList[0] &&
                    this.properties.imageList[0].imageName) ||
                  '',
              },
            })
          })
          // 调用单击事件
          triggerActions(dNode.uid, 'click', classifyActions(actions))
        },
        // iphonex向上滑动时，去除底部padding
        checkIphonexBottom() {
          const scale = window.innerWidth / window.screen.width
          if (window.screen.height - window.innerHeight / scale < 110) {
            this.isIphonexBottomCls = true
          } else {
            this.isIphonexBottomCls = false
          }
          this.handlePagePd(this.isIphonexBottomCls)
        },
        // 获取页面padding
        getPagePadding() {
          const pageEl = document.body.querySelector('.niffler-page')
          const paddingBottom = pageEl.style.paddingBottom
          if (paddingBottom === 'auto') {
            return 0
          }
          return parseFloat(paddingBottom)
        },
        // 设置页面padding
        handlePagePd(isNeed) {
          this.$nextTick(() => {
            const currentPd = this.getPagePadding()
            let newPd = isNeed ? this.originPadding + 0.4 : this.originPadding
            if (newPd === currentPd) {
              return false
            } else if (newPd < currentPd) {
              newPd = currentPd
            }
            const pageEl = document.body.querySelector('.niffler-page')
            pageEl.style.paddingBottom = newPd + 'rem'
          })
        },
      },
      mounted() {
        // 根据数据源异步加载数据
        triggerService(dNode.service, props => {
          // 改变引用形式触发properties响应
          this.properties = Object.assign({}, this.properties, props)
        })
        if (!isServer) {
          this.originPadding = this.getPagePadding()
        }
        if (this.isIphonexBottom && !isServer) {
          this.checkIphonexBottom()
          window.onscroll = this.checkIphonexBottom
        }
      },
      render() {
        const baseComponent = h(
          // 渲染对应的组件
          dNode.componentName,
          {
            props: this.properties,
            style: widgetStyle,
            class: {
              'fix-iphonex-bottom':
                this.isIphonexBottom && this.isIphonexBottomCls,
            },
            nativeOn: {
              click: e => this.handleComponentClick(e),
            },
          },
          // 只有容器组件才可以挂载子节点
          // 非容器组件的子节点需要将子节点转换为并列的兄弟节点
          // 兼容某些组件内部未写插槽问题。
          children.length > 0 && isContainer ? children : dNode.textNode || ''
        )

        return h(
          'div',
          {
            attrs: {
              'data-type': dNode.oldType || dNode.type,
              class:
                style['position'] === 'fixed'
                  ? 'fixed-container'
                  : 'niffler-container',
              niffleruid: dNode.uid,
              componentName: dNode.aliasName,
            },
            style: [
              style,
              this.properties.setAnimate ? { overflow: 'hidden' } : {},
            ],
          },
          [baseComponent, isContainer ? null : children]
        )
      },
    },
    {
      slot: dNode.slotName || 'default',
    }
  )
}

const MyComponent = Vue.component('my-component', {
  render: function(h) {
    const status = this.nodes.status
    const propsData = this.nodes.propsData
    const statusData = propsData[status]
    const style = transformStyle(cloneDeep(statusData['style']))
    const properties = cloneDeep(statusData['description'])
    // 增加全局eventBus,便于组件内部调用
    window.eventBus = eventBus
    window.formCheck = {}
    // 全局存放了formData字段，代码在app.vue
    window.eventBus.$on('formUpdate', options => {
      let { uid, formData, global } = options
      window.formData[uid] = { formData, global }
    })
    window.eventBus.$on('formRecover', options => {
      let { uid, callback, checkFn } = options
      formCheck[uid] = checkFn
      if (typeof callback === 'function') {
        window.getFormData.then(() => {
          callback(window.formData[uid] || { formData: {}, global: {} })
        })
      }
    })
    return h(
      'ZybPage',
      {
        style,
        props: properties,
        class: ['niffler-page'],
      },
      createComponent(
        this.nodes.pageContent,
        h,
        {
          actInfo: this.actInfo,
          pageId: this.nodes.pageId,
        },
        this.nodes
      )
    )
  },
  props: {
    nodes: {
      type: Object | Array,
      required: true,
    },
    actInfo: {
      type: Object | Array,
      required: true,
    },
  },
})

export default MyComponent
</script>
<style lang="less">
.niffler-container {
  position: relative;
}
.fix-iphonex-bottom {
  // transition: padding 0.2s ease;
  &.zyb-pay,
  &.zyb-fix-order,
  &.zyb-flash-sale-button,
  &.btn-container {
    padding-bottom: 0.4rem !important;
  }
}
</style>
